import React from 'react'
import { useSession } from '@slerp/accounts'
import {
  CREATE_PRODUCT_VARIANTS,
  ADD_PRODUCT_OPTIONS,
  CREATE_STORE_VARIANTS
} from '../ProductQueries'
import { ProductVariant, StoreId, ProductInfo } from '@slerp/controls'
import { useMutation, useApolloClient } from '@apollo/client'
import { Form, Button, Row, Col, Modal, Input, Select, message } from 'antd'
import { variants } from '../actions'
import { Store } from 'antd/lib/form/interface'
const { useForm } = Form

interface VariantsAddOptionModalProps {
  show: boolean
  setShow: (value: boolean) => void
  productVariants: Array<ProductVariant>
  product: ProductInfo
  storeId: Array<StoreId>
}

const VariantsAddOptionModal = (props: VariantsAddOptionModalProps) => {
  const { show, setShow, productVariants, product, storeId } = props
  const client = useApolloClient()
  const [form] = useForm()
  const { user } = useSession()

  const [createProductVariants] = useMutation(CREATE_PRODUCT_VARIANTS)
  const [createStoreVariants] = useMutation(CREATE_STORE_VARIANTS)
  const [addProductOptions] = useMutation(ADD_PRODUCT_OPTIONS)

  const onFinish = (values: Store) => {
    message.loading('Creating Product Variant... Please Wait.')
    const { insertValues, store_variants } = variants({
      productVariants,
      storeId,
      values,
      product,
      user
    })

    createProductVariants({
      variables: {
        values: insertValues
      }
    }).then((result) => {
      createStoreVariants({
        variables: {
          values: store_variants
        }
      })

      addProductOptions({
        variables: {
          product_id: product.id,
          options: {
            name: values.name,
            values: values.options
          }
        }
      })

      message.destroy()
      client.resetStore()
      message.success('Product Variant Created!', 1)
      setShow(false)
      form.resetFields()
    })
  }

  return (
    <Modal
      data-testid='add-option-modal'
      title='Create Option'
      visible={show}
      closable={false}
      footer={null}
    >
      <Form form={form} onFinish={onFinish}>
        <label>Name</label>
        <Row>
          <Form.Item name='name'>
            <Input
              type='text'
              autoFocus
              required
              size='large'
              placeholder='Enter option name'
            />
          </Form.Item>
        </Row>
        <label>Option Values</label>
        <Row style={{ marginBottom: '24px' }}>
          <Form.Item
            name='options'
            style={{ width: '100%' }}
            rules={[{ required: true, message: 'This is a required field' }]}
          >
            <Select
              size='large'
              mode='tags'
              placeholder='Enter one value e.g. small'
            />
          </Form.Item>
        </Row>

        <hr
          style={{
            borderColor: '#e8e8e8',
            borderStyle: 'none none solid',
            margin: '24px 0',
            width: '100%'
          }}
        />

        <Row justify='end'>
          <Col>
            <Button
              type='text'
              onClick={() => {
                setShow(false)
              }}
            >
              Cancel
            </Button>
            <Button type='primary' htmlType='submit'>
              Save
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

export default VariantsAddOptionModal
